var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfinity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252,128a59.99981,59.99981,0,0,1-102.42627,42.42627q-.25709-.25708-.49805-.5293L89.21533,102.30615a36,36,0,1,0,0,51.3877L92.30078,150.21a12,12,0,0,1,17.9668,15.91211l-3.34326,3.7749q-.241.27173-.498.5293a60,60,0,1,1,0-84.85254q.25709.25709.498.5293l59.86035,67.59082a36,36,0,1,0,0-51.3877L163.69922,105.79a12,12,0,0,1-17.9668-15.91211l3.34326-3.7749q.241-.27174.49805-.5293A60,60,0,0,1,252,128Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/Infinity.6c2fd7ac62c7c8be4553663389b728a3.svg";
export { ForwardRef as ReactComponent };